export default __webpack_public_path__ + "static/media/letterjumble_standard.2b5472a3.svg";